<template>
  <v-snackbar :color="successBackgroundTint" :value="value" @input="emitInput">
    <v-icon :color="successColor" left>{{ mdiCheckCircle }}</v-icon>
    <span
      style="font-family: system-ui !important; font-weight: 500"
      :style="{ color: successColor }"
      >{{ message }}</span
    >
    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        min-width="24"
        text
        :color="successColor"
        @click="emitInput(false)"
      >
        <v-icon :color="successColor">{{ mdiClose }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiCheckCircle, mdiClose } from "@mdi/js"
import { successBackgroundTint, successColor } from "constants/theme"
import TextBody from "components/UI/TextBody.vue"
import { useThemeColors } from "features/common/theme/useTheme"

export default defineComponent({
  name: "SuccessSnackbar",
  components: { TextBody },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const emitInput = (value: boolean) => {
      emit("input", value)
    }
    const themeColors = useThemeColors()
    return {
      emitInput,
      mdiCheckCircle,
      successBackgroundTint,
      themeColors,
      mdiClose,
      successColor,
    }
  },
})
</script>
